import * as React from 'react';
import styled, { css } from 'styled-components';

const IMAGE_OFFSET = -200;

const Wrapper = styled.div<{ $position: 'left' | 'right' }>`
  display: block;
  float: right;
  position: relative;

  ${({ $position }) =>
    $position === 'left' &&
    css`
      float: left;
      padding: 0 20px 0 0;
      margin-left: ${IMAGE_OFFSET}px;
    `}

  ${({ $position }) =>
    $position === 'right' &&
    css`
      float: right;
      padding: 0 0 0 20px;
      margin-right: ${IMAGE_OFFSET}px;
    `}

    @media (max-width: ${({ theme }) => theme.mediaQuery.SMALL}) {
    width: 100%;
    float: none;
    margin: 0 !important;
    padding: 0 0 20px !important;

    img {
      max-width: 100%;
    }
  }
`;

interface FloatImageProps {
  offset: string;
  path?: string;
  position: 'left' | 'right';
  src?: string;
}

export const FloatImage: React.ComponentType<FloatImageProps> = React.memo(
  ({ path, position, src, offset }) => {
    return (
      <Wrapper
        $position={position}
        style={
          position === 'left'
            ? {
                marginLeft: -offset
              }
            : {
                marginRight: -offset
              }
        }>
        <img
          alt={path}
          src={src || `/images/floating/${path}.png`}
          srcSet={
            src
              ? `${src} 2x`
              : `/images/floating/${path}.png 1x, /images/floating/${path}@2x.png 2x`
          }
        />
      </Wrapper>
    );
  }
);
